import { defineManifest } from '@ndrc/app-sdk/manifest';
import { emitsOf } from '@ndrc/app-sdk/events';
import { events } from './events.js';
import fr from './messages/fr.json' with { type: 'json' };
export const manifest = defineManifest({
  id: 'campaigns',
  name: fr.title,
  description: fr.description,
  icon: 'mail',
  color: 'blue',
  version: '0.1.0',
  sdk: '0.0.0',
  status: 'dev',
  category: 'relation-client',
  permissions: {
    uses: ['app.records.read', 'app.records.write', 'contacts.read', 'contacts.write'],
    defines: [],
  },
  entities: {
    uses: [{ entity: 'contacts' }],
    owns: [
      { table: 'campaigns', scope: 'workspace', description: fr.title },
      { table: 'runs', scope: 'workspace', description: fr.runTitle },
      { table: 'receipts', scope: 'workspace', description: fr.saved },
      { table: 'templates', scope: 'workspace', description: fr.templates },
    ],
  },
  events: {
    emits: emitsOf(events),
    subscribes: [{ type: 'campaigns.run.due', handler: 'onRunDue' }],
  },
  ui: {
    student: { defaultRoute: '/', routes: [{ path: '/', title: fr.title }], layout: 'full' },
    teacher: { panel: true, widgets: [], studentInspector: true },
  },
  missions: { actions: ['campaigns.seed'], conditions: ['campaigns.completed'], blocks: [] },
  migrations: { schema: 'app_campaigns', dir: 'migrations' },
});
